<template>
	<div id="showSecSign">
		<div name="bind">
		</div>
	</div>
</template>

<script>
import { bucketName } from "@/resources.js"
import { API_SecSeal, API_Common, API_CONST, API_Video } from "@/api/api.js"
import JS_secSeal from "@/tool/secSeal.js"
import { getRandomNum } from "@/tool/parse.js"
export default {
	// sealInfo获取模版文件盖章
	// uploadInfo上传的回调
	// hideFun 主要是针对主要材料报验只要批量盖章 true:盖章按钮不可用
	// type 判断是要从监管端还是从阿里云取文件
	// rpx 模板
	props: ["rpx", "id", "isView", "uploadInfo", "sealInfo", "type" ,"hideFun","dataObj"],
	data() {
		return {
			isFromSupervisorEnd: false, //isFromSupervisorEnd是否从监管端来的盖章文件
			bind: { filePath: "", sealStr: "", sealFilePath: "", fileName: "" },
			res: false,
			client: {},
			oMe: {},
			returnId: null
		}
	},
	watch: {
		res() {
			if (this.res) {//listform获取成功
				if (this.isView) {
					this.sealV();
				} else {
					this.seal();
				}
			}
		}
	},
	created() {
	},
	mounted() {
		let hideFun = this.hideFun;
		this.oMe = this;
		let me = this;
		JS_secSeal.sealBack = this.sealBack;
		JS_secSeal.onload(this,true);
		JS_secSeal.isHidden(hideFun);
		this.sealInfo.params["rpx"] = this.rpx;
		this.sealInfo.params["recordId"] = this.id;
		console.log(this.sealInfo)
		API_SecSeal.seal(this.sealInfo.controllName, this.sealInfo.method, this.sealInfo.params).then(res => {
            console.log(res);
            if (res.id != null) {
                me.returnId = res.id;
                me.$emit("passSealId", res.id);
			}
			if(res.seal != undefined){
			    res = res.seal;
            }
			if (res.result == true || res.result == "true") {
				this.bind.filePath = res.data.filePath; //盖章的pdf
				this.bind.fileName = res.data.fileName;
				this.isFromSupervisorEnd = (res.type ? res.type === "getFromSupervisorEnd" : false);
				this.res = true;
				try {
					let client = new OSS.Wrapper({
						region: 'oss-cn-hangzhou',
						//云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
						accessKeyId: API_CONST.accessKeyId,
						accessKeySecret: API_CONST.accessKeySecret,
						bucket: API_CONST.bucketName
					});
					this.client = client;
				}
				catch (ex) {
				}
			} else {
				this.$alert(res.message != null ? res.message : "系统出错请稍后再试", "错误", {
					confirmButtonText: "确定",
					type: "error"
				})
				this.$emit("closeSecSeal", { success: false })
			}
		})
	},
	beforeDestroy() {
		if (JS_secSeal.socket == null)
			return;
		try {
			JS_secSeal.socket.close();
			JS_secSeal.socket = null;
		}
		catch (ex) {
		}
	},
	methods: {
		afterSeal() {

		},
		secSeal_onload: JS_secSeal.onload,
		sealV() {
			//查看盖章
			JS_secSeal.viewSeal(this.bind.filePath, this.isFromSupervisorEnd);
		},
		seal() {
			//签章
			let url = this.bind.filePath;
			if (this.isFromSupervisorEnd) {//从监管的来的数据，要转换+头
				url = API_CONST.SupervisorSecSealURL + this.bind.filePath.replace(/\\\\/g, "/");
			} else {
				if (!url.startsWith("http")) {
					// 可能是阿里的oss
					let suffix = (url.substring(url.lastIndexOf(".") + 1, url.length) == "pdf" ? "pdf" : "edc");
					let fileName = url.substring(0, url.lastIndexOf("."));
					url = this.client.signatureUrl(url, {
						response: {
							'content-disposition': 'attachment; filename="' + fileName + "." + suffix + '"'
						}
					})
				}
			}
			// console.log("盖章签章url : " + url);
			JS_secSeal.onSeal(url);
		},
		sealBack(res, base64) {// 签章保存的回调
			// console.log(" 签章保存的回调 =" , res)
			// 签章/查看签章关闭后都会调用这个函数
			if (!res)
				return;
			let op = "close"
			var json = JSON.parse(res);
			// JS_secSeal .onbeforeunload();
			// console.log(json)
			if (json.PluginResponseValue != "" && json.PluginResponseValue != "SUCCESS") {
				// this.bind.sealStr = json.PluginResponseValue;
				this.bind.sealStr = base64;
				//上传
				this.uploadFile(this.bind.sealStr);
				op = "upload"
			}
			else {
				// console.log("查看签章的回调，暂时放空")
			}
			this.$emit("closeSecSeal", { success: true, op: op })
		},
		//上传签章文件
		uploadFile(base64) {
			let me = this;
			// let fileName = getRandomNum(16);
			// secSign/签章文件上传成功后回调的接口controllerName/报表模版名称/年/月/日/pdf的名字.edc
			// let key = "secSign/" + me.uploadInfo.controllName + "/" + this.rpx + "/" + date.getFullYear() + "/" + (month > 9 ? month : '0' + month) + "/" + (day > 9 ? day : '0' + day) + "/" + fileName + ".edc";
			// console.log(this.client.multipartUpload == null)

			let fileName;
			let filePath = "";
			if (this.bind.filePath.startsWith("current")) {
				filePath = "supervisorSecSeal/";
				fileName = this.bind.filePath;
			} else {
				filePath = this.bind.filePath.substring(0, this.bind.filePath.lastIndexOf("/") + 1);
				fileName = this.bind.fileName.split(".")[0] + '.edc';
			}
			try {
				let file = new File([this.convertBase64UrlToBlob(base64)], fileName);
				this.client.multipartUpload(filePath + fileName, file, {}).then(function(res) {
					let id = ""
					if (me.id != "" && me.id != null) {
						id = me.id;
					} else if (me.returnId != null) {
						id = me.returnId;
					}
                    let params = {};
					if(me.uploadInfo.method ==  "personLeaveSPFirst" || me.uploadInfo.method ==  "personLeaveSPFinal"){
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" ,data:me.dataObj};
                    }else {
                        params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" }
                    }
                    if (me.uploadInfo.method === 'confirmBackFun') {
					  if (me.uploadInfo.controllName == 'videoRemove') {
                        API_Video.confirmVideoRemove(me.sealInfo.params).then(res => {
                          if (res.success) {
                            API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                              // 返回url后可能还有后续操作，写在各自的函数里
                              if (res.success) {
                                me.$notify({
                                  message: "签章文件上传成功",
                                  type: "info",
                                  offset: document.body.clientHeight - 200,
                                  duration: 2000,//设置为0则不fengu自动关闭
                                });
                                me.uploadcomplete();
                              } else {
                                this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                  confirmButtonText: '确定',
                                  type: "error"
                                });
                                this.$emit("closeSecSeal", { success: false, op: "close" })
                              }
                            })
                          } else {
                            this.$alert('签章文件上传出错，请稍候再次上传', '', {
                              confirmButtonText: '确定',
                              type: "error"
                            });
                            this.$emit("closeSecSeal", { success: false, op: "close" })
                          }
                        });
                      } else {
                        API_Video.confirmVideoPause(me.sealInfo.params).then(res => {
                          if (res.success) {
                            API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                              // 返回url后可能还有后续操作，写在各自的函数里
                              if (res.success) {
                                me.$notify({
                                  message: "签章文件上传成功",
                                  type: "info",
                                  offset: document.body.clientHeight - 200,
                                  duration: 2000,//设置为0则不fengu自动关闭
                                });
                                me.uploadcomplete();
                              } else {
                                this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                  confirmButtonText: '确定',
                                  type: "error"
                                });
                                this.$emit("closeSecSeal", { success: false, op: "close" })
                              }
                            })
                          } else {
                            this.$alert('签章文件上传出错，请稍候再次上传', '', {
                              confirmButtonText: '确定',
                              type: "error"
                            });
                            this.$emit("closeSecSeal", { success: false, op: "close" })
                          }
                        });
                      }
                    } else {
                      API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                        // 返回url后可能还有后续操作，写在各自的函数里
                        if (res.success) {
                          me.$notify({
                            message: "签章文件上传成功",
                            type: "info",
                            offset: document.body.clientHeight - 200,
                            duration: 2000,//设置为0则不fengu自动关闭
                          });
                          me.uploadcomplete();
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      })
                    }
				});
			} catch (ex) {
				console.log("使用后台上传文件的方法", ex)
				// 使用后台上传文件的方法
				this.uploadByJava(filePath , fileName, base64);
				// this.$alert("IE浏览器或360浏览器的兼容模式不支持文件上传，请使用谷歌浏览器、360浏览器的“极速模式”。", "错误", {
				// 	confirmButtonText: "确定",
				// 	type: "error"
				// })
			}
		},
		uploadByJava(filePath , fileName, base64 ) {
			console.log("uploadByJava")
			let me = this;
			// console.log(key);
			// console.log(base64);
			API_Common.uploadByJava({ data: base64, key: filePath + fileName }).then(ubj => {
				if (ubj.success) {
					let id = ""
					if (me.id != "" && me.id != null) {
						id = me.id;
					} else if (me.returnId != null) {
						id = me.returnId;
					}
					let params = { id: id, fileName: fileName, filePath: filePath + fileName, displayName: fileName, fileSuffix: "edc" }
                  if (me.uploadInfo.method === 'confirmBackFun') {
                    if (me.uploadInfo.controllName === 'videoRemove') {
                      API_Video.confirmVideoRemove(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    } else {
                      API_Video.confirmVideoPause(me.sealInfo.params).then(res => {
                        if (res.success) {
                          API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                            // 返回url后可能还有后续操作，写在各自的函数里
                            if (res.success) {
                              me.$notify({
                                message: "签章文件上传成功",
                                type: "info",
                                offset: document.body.clientHeight - 200,
                                duration: 2000,//设置为0则不fengu自动关闭
                              });
                              me.uploadcomplete();
                            } else {
                              this.$alert('签章文件上传出错，请稍候再次上传', '', {
                                confirmButtonText: '确定',
                                type: "error"
                              });
                              this.$emit("closeSecSeal", { success: false, op: "close" })
                            }
                          })
                        } else {
                          this.$alert('签章文件上传出错，请稍候再次上传', '', {
                            confirmButtonText: '确定',
                            type: "error"
                          });
                          this.$emit("closeSecSeal", { success: false, op: "close" })
                        }
                      });
                    }
                  } else {
                    API_Common.post(me.uploadInfo.controllName, me.uploadInfo.method, params).then(res => {
                      // 返回url后可能还有后续操作，写在各自的函数里
                      if (res.success) {
                        me.$notify({
                          message: "签章文件上传成功",
                          type: "info",
                          offset: document.body.clientHeight - 200,
                          duration: 2000,//设置为0则不自动关闭
                        });
                        me.uploadcomplete();
                      } else {
                        this.$alert('签章文件上传出错，请稍候再次上传', '', {
                          confirmButtonText: '确定',
                          type: "error"
                        });
                        this.$emit("closeSecSeal", {success: false, op: "close"})
                      }
                    })
                  }
				} else {
					this.$alert(ubj.msg,'签章文件上传出错，请稍候再次盖章' , {
						confirmButtonText: '确定',
						type: "error"
					});
					this.$emit("closeSecSeal", { success: false, op: "close" })
				}
			})
		},
		uploadcomplete() {
			this.$emit("uploadcomplete")
		},
		convertBase64UrlToBlob(base64) {
			var bytes = window.atob(base64); //去掉url的头，并转换为byte
			//处理异常,将ascii码小于0的转换为大于0
			var ab = new ArrayBuffer(bytes.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < bytes.length; i++) {
				ia[i] = bytes.charCodeAt(i);
			}
			return new Blob([ab]);
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// showSecSign.vue?776e4126